import * as types from './actionTypes';  
import createBrokerdealerApi from '../api/createBrokerdealerApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCreateBrokerdealer(request) {

  return {
    type: types.DO_CREATE_BROKERDEALER, 
    request
  };
}

export function doCreateBrokerdealerRes(data) {  
  return {
    type: types.DO_CREATE_BROKERDEALER_RES, 
    data
  };
}

export function createBrokerdealer(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      createBrokerdealerApi.doCreateBrokerdealer(request).then(data => {
        dispatch(doCreateBrokerdealerRes(data));
        dispatch(doCreateBrokerdealerRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}